module.exports = __webpack_public_path__ + "img/bone-mapping.30de630b.png";